export default () => ({
  filtersSource: null,
  invoices: {
    loading: false,
    items: [],
    pagination: {
      limit: 24,
      offset: 0,
      countTotal: 0,
    },
    sort: {
      value: '',
      direction: 'DESC',
    },
    activeFilters: {},
  },
  orders: {
    loading: false,
    items: [],
    pagination: {
      limit: 24,
      offset: 0,
      countTotal: 0,
    },
    sort: {
      value: '',
      direction: 'DESC',
    },
    activeFilters: {},
    availableFilters: {},
  },
  ordersToAcceptance: {
    loading: false,
    items: [],
    pagination: {
      limit: 24,
      offset: 0,
      countTotal: 0,
    },
    sort: {
      value: '',
      direction: 'DESC',
    },
    activeFilters: {},
    availableFilters: {},
  },
  complaints: {
    loading: false,
    items: [],
    pagination: {
      limit: 24,
      offset: 0,
      countTotal: 0,
    },
    sort: {
      value: '',
      direction: 'DESC',
    },
    activeFilters: {},
  },
});
